var _g, _line, _polyline, _line2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 241.6 160.3",
    style: {
      overflow: "visible"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heart",
    className: "opacity-0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M157,5.3c11.1,0,22.3,4.3,30.8,12.8c17.1,17.1,17.1,44.5,0,61.6l-11.1,11.1l-63.6,63.6L38.4,79.7 c-17.1-17.1-17.1-44.5,0-61.6C46.9,9.6,58.1,5.3,69.2,5.3S91.5,9.6,100,18.1l0,0l11.1,11.1l0,0c1.1,1.1,2.8,1.1,3.9,0l11.1-11.1 C134.7,9.6,145.8,5.3,157,5.3L157,5.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fill-green",
    d: "M187.6,19.8C179.1,11.3,167.9,7,156.8,7l0,0c-11.1,0-22.3,4.3-30.8,12.8l-11.1,11.1 c-0.6,0.6-1.5,0.9-2.4,0.8l7.7,7.7l0,0c0.9,0.9,2.4,0.9,3.3,0l9.4-9.4c7.3-7.3,16.7-10.9,26.2-10.9l0,0 c9.5,0,18.9,3.6,26.2,10.9c14.5,14.5,14.5,37.8,0,52.4l-9.4,9.4l-54,54L58.4,82.3c-14.5-14.5-14.5-37.8,0-52.4 C65.7,22.6,75.1,19,84.6,19c7.4,0,14.8,2.2,21.2,6.7l-6-6l0,0C91.3,11.2,80.1,6.9,69,6.9s-22.3,4.3-30.8,12.8 c-17.1,17.1-17.1,44.5,0,61.6l74.7,74.7l63.6-63.6l11.1-11.1C204.7,64.3,204.7,36.9,187.6,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fill-dkgreen",
    d: "M111,30.9c0.4,0.4,1,0.7,1.6,0.8l-1.7-1.7l0,0c-1.6-1.6-3.2-2.9-5-4.2L111,30.9L111,30.9z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "heart-outline",
    className: "stroke-6 stroke-white",
    d: "M157,5.3c11.1,0,22.3,4.3,30.8,12.8c17.1,17.1,17.1,44.5,0,61.6l-11.1,11.1l-63.6,63.6L38.4,79.7 c-17.1-17.1-17.1-44.5,0-61.6C46.9,9.6,58.1,5.3,69.2,5.3S91.5,9.6,100,18.1l0,0l11.1,11.1l0,0c1.1,1.1,2.8,1.1,3.9,0l11.1-11.1 C134.7,9.6,145.8,5.3,157,5.3L157,5.3z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "dot-right",
    className: "stroke-6 stroke-white stroke-round opacity-0",
    x1: 235.4,
    y1: 77.4,
    x2: 237.2,
    y2: 77.4
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "rate",
    className: "stroke-6 stroke-white stroke-dash stroke-round",
    points: "15,77 86.7,77 103.6,105.9 121.3,49.3 140.2,77 225.6,77 "
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "dot-left",
    className: "stroke-6 stroke-white stroke-round opacity-0",
    x1: 4.7,
    y1: 77.4,
    x2: 6.4,
    y2: 77.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.a008b1793bb6b85ad6181ede9e0ad245.svg";
export { ForwardRef as ReactComponent };